import { Navigate, Outlet, Route, Routes } from 'react-router';
import { AlivePage } from './components/alive/AlivePage';
import { RequireSignIn } from './components/auth/RequireSignIn';
import { ConfirmSignUpPage } from './components/auth/pages/ConfirmSignUpPage';
import { ForgotPasswordPage } from './components/auth/pages/ForgotPasswordPage';
import { GoogleCallbackPage } from './components/auth/pages/GoogleCallbackPage';
import { SignInPage } from './components/auth/pages/SignInPage';
import { SignUpPage } from './components/auth/pages/SignUpPage';
import { ChangelogPage } from './components/changelog/ChangelogPage';
import { JobPage } from './components/job/pages/JobPage';
import { JobsPage } from './components/job/pages/JobsPage';
import { NewJobPage } from './components/job/pages/NewJobPage';
import { UserJobsPage } from './components/job/pages/UserJobsPage';
import { JobConfigPage } from './components/jobConfig/pages/JobConfigPage';
import { JobConfigsPage } from './components/jobConfig/pages/JobConfigsPage';
import { Footer } from './components/nav/Footer';
import { Navbar } from './components/nav/Navbar';
import { SourcesPage } from './components/source/pages/SourcesPage';
import { TagsPage } from './components/tag/pages/TagsPage';
import { TaskListPage } from './components/task/pages/TaskListPage';
import { TaskPage } from './components/task/pages/TaskPage';

/** The sign-in pages are public (QZ-D28); everything else is gated (QZ-D18). */
export const App = () => (
  <Routes>
    <Route path="/signin" element={<SignInPage />} />
    <Route path="/signup" element={<SignUpPage />} />
    <Route path="/signup/confirm" element={<ConfirmSignUpPage />} />
    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
    <Route path="/auth/google/callback" element={<GoogleCallbackPage />} />
    <Route
      element={
        <RequireSignIn>
          <Navbar />
          <Outlet />
          <Footer />
        </RequireSignIn>
      }
    >
      <Route path="/" element={<Navigate to="/tasks" replace />} />
      <Route path="/tasks" element={<TaskListPage />} />
      <Route path="/tasks/:taskId" element={<TaskPage />} />
      <Route path="/tags" element={<TagsPage />} />
      <Route path="/jobs" element={<JobsPage />} />
      <Route path="/jobs/new" element={<NewJobPage />} />
      <Route path="/jobs/:jobId" element={<JobPage />} />
      <Route path="/user-jobs" element={<UserJobsPage />} />
      <Route path="/sources" element={<SourcesPage />} />
      <Route path="/job-configs" element={<JobConfigsPage />} />
      <Route path="/job-configs/new" element={<JobConfigPage />} />
      <Route path="/job-configs/:jobConfigId" element={<JobConfigPage />} />
      <Route path="/alive" element={<AlivePage />} />
      <Route path="/changelog" element={<ChangelogPage />} />
    </Route>
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default App;
